import { MutationTree } from 'vuex';
import { State } from './wsm.store';
import WSMTypes from '@/store/modules/wsm/wsmTypes';

const mutations: MutationTree<State> = {
  setCurrentWSMType(state: State, data: any) {
    state.currentWSMType = data;
  },
  setCurrentWSMService(state: State, data: any) {
    state.currentWSMService = data;
  },
  setWSMServices(state: State, data: any) {
    state.wsmServices = data;
  },
  // resets to default values on logout
  setDefaultValues(state: State, data: any) {
    const keyLabel = {
      key: '',
      label: '',
      permissions: [],
    };
    state.currentWSMType = WSMTypes[0];
    state.wsmServices = [];
    state.currentWSMService = keyLabel;
  }
};

export default mutations;
